<template>
  <div class="container_presentation" v-if="course.name">
    <div class="spacer"></div>
    <div class="spacer"></div>
    <b-container>
      <b-row>
        <b-col md="3" class="side_logo_container">
          <img class="side_logo" src="@/assets/img/logo_rectangle_sm.png" alt="Logo challenge maritima" />
        </b-col>
        <b-col md="6">
          <h2 style="font-weight: bold">{{ course.name }} - {{ course.distance }}</h2>
          <h4>{{ course.date }}</h4>
        </b-col>
        <b-col md="3" class="side_logo_container">
          <img class="side_logo" src="@/assets/img/Logo_TotalEnergies.png" alt="Logo Total energies" />
        </b-col>
      </b-row>
      <b-row>
        <b-col offset-md="3" md="6">
          <div class="spacer"></div>
          <img src="@/assets/img/courses/Embruns Ensemble_parcours.jpg" alt="" />
          <div class="spacer"></div>

          <p>
            Créé en 1999, la Course des Embruns est une boucle de 11,2km entre mer et colline.<br />

            Un décor de rêve que seul le rivage de la Côte bleue peut offrir.<br />

            Vous longerez la mer et profiterez de notre corniche pendant 7 km, le reste du parcours se situant sur des chemins entourés de verdure.<br />

            Vous aurez des points de vue magnifiques sur la mer et sur le port ; vous traversez la Roselière, un espace naturel où plusieurs espèces maritimes viennent se reproduire.<br />
          </p>
          <br />
          <p>
            - Récompenses aux 3 premiers du scratch et au 1er de chaque catégorie<br />

            - Un cadeau offert à chaque coureur et un tirage au sort de lots après la course<br />

            - Animation par Kamel Amiri<br />

            - Échauffement collectif avant le départ de la course
          </p>
        </b-col>
      </b-row>
      <div class="spacer"></div>
      <div class="spacer"></div>
      <b-row>
        <b-col md="2"></b-col>
        <b-col md="4">
          <img src="@/assets/img/courses/Départ Embruns 2022.jpg" alt="" />
        </b-col>
        <b-col md="4">
          <img :src="'https://sportips.fr/challenge-maritima/img/flyer/' + course.url_flyer" alt="" />
        </b-col>
      </b-row>

      <hr />
      <b-row>
        <b-col>
          <p><b>Contact : Philippe Lacues 06 82 36 33 08</b></p>
        </b-col>
      </b-row>
      <div class="spacer"></div>
      <b-row>
        <b-col>
          <b-button class="infos_btn" download href="https://sportips.fr/challenge-maritima/uploads/Fichier GPX Course des Embruns Sausset.gpx" target="_blank">GPX de l'épreuve</b-button>
          <b-button class="infos_btn" href="http://coursedesembruns.com" target="_blank">Infos course</b-button>

          <b-button class="infos_btn" download href="https://sportips.fr/challenge-maritima/uploads/Reglement_embruns.doc" target="_blank">Réglement</b-button>
          <b-button class="infos_btn" href="http://kms.fr" target="_blank">Inscriptions</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: ["course"],
  created() {},
};
</script>

<style lang="scss" scoped>
</style>